import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

import { WallTypes } from '@app/catalog/category/plans/wall-type.interface';
import { CustomerContextService } from '@app/context/child/customer-context.service';

@Injectable({
    providedIn: 'root',
})
export class ProService {
    private isPro: boolean;
    private isProClientType: boolean;

    constructor(private customerContextService: CustomerContextService, private activatedRoute: ActivatedRoute) {}

    private isProContext(): boolean {
        const renewalOrAcc = RegExp(/renouvellement|accessoires|bons-plans/).test(window.location.href);
        return !renewalOrAcc && !!this.isProClient();
    }

    public isProClient(): boolean {
        return (
            this.customerContextService.isEnterprise() ||
            window.location.href.includes('telephones-mobiles-pro') ||
            window.location.href.includes('forfaits-mobiles-pro')
        );
    }

    public getIsPro(): boolean {
        if (typeof this.isPro !== 'boolean') {
            this.isPro = this.isProContext();
        }

        return this.isPro;
    }

    public getIsProClientType(): boolean {
        if (typeof this.isProClientType !== 'boolean') {
            this.isProClientType = this.isProClient();
        }

        return this.isProClientType;
    }

    public isOnProWall(): boolean {
        const recursiveProChildrenLookup = (children: ActivatedRouteSnapshot[]): boolean =>
            children.some((child) => child.data.type === WallTypes.PRO || recursiveProChildrenLookup(child.children));

        return recursiveProChildrenLookup([this.activatedRoute.snapshot]);
    }
}
